const { createContext, useContext } = require('react');

const FormAddressContext = createContext({
  formConfigs: {},
  isInRebrand: false,
  isMobile: false,
});

const useFormAddress = () => {
  const configs = useContext(FormAddressContext);

  return configs;
};

module.exports = {
  FormAddressContext,
  useFormAddress,
};
